export default __webpack_public_path__ + "static/media/Rectangle 3513.5723137d.svg";